export default [
  {
    path: "/my-push",
    name: "push",
    meta: { title: "My-Push" },
    component: () => import("../views/push/push-list/push-list.vue")
  }
]